import Vue from 'vue';
import Router from 'vue-router';

// 比赛
import Index from './pages/match/index/index'
import Awards from './pages/match/awards/index'
import MatchPre from './pages/match/pre/index'
import MatchFinal from './pages/match/final/index'
import Winners from './pages/match/winners/index'
import MatchRules from './pages/match/rules/index'
import MyIndex from './pages/match/my/index'
import MyAwards from './pages/match/my/awards'
import MyAddress from './pages/match/my/address'
import MyBind from './pages/match/my/bind';

// 实盘
import RealityIndex from './pages/reality/index/index'
import RealityPlay from './pages/reality/play/index'
import RealityFinish from './pages/reality/finish/index'
import RealityGames from './pages/reality/games/index'
import RealityRank from './pages/reality/rank/index'

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'index',
    component: Index,
    meta: {
      title: '斗K“股神”训练争霸赛',
      tabIndex: 0 // 数字：显示底导航    false: 不显示
    }
  },
  {
    name: 'my',
    path: '/match/my',
    component: MyIndex,
    meta: {
      title: '我的战况-斗K“股神”训练争霸赛',
      tabIndex: 999
    }
  },
  {
    name: 'myAwards',
    path: '/match/my/awards',
    component: MyAwards,
    meta: {
      title: '我的奖项-斗K“股神”训练争霸赛',
      tabIndex: 999
    }
  },
  {
    name: 'myAddress',
    path: '/match/my/address',
    component: MyAddress,
    meta: {
      title: '领奖信息填写-斗K“股神”训练争霸赛',
      tabIndex: 999
    }
  },
  {
    name: 'myBind',
    path: '/match/my/bind',
    component: MyBind,
    meta: {
      title: '账号绑定-斗K“股神”训练争霸赛',
      tabIndex: 999
    }
  },
  {
    name: 'reality',
    // path: '/reality(/index)?',
    component: RealityIndex,
    meta: {
      title: '猜涨跌-斗K“股神”训练争霸赛',
      tabIndex: -1
    }
  },
  {
    path: '/reality/games',
    component: RealityGames,
    props: true ,
    meta: {
      title: '决赛记录-斗K“股神”训练争霸赛'
    }
  },
  {
    path: '/reality/rank',
    component: RealityRank,
    props: true ,
    meta: {
      title: '排行榜-斗K“股神”训练争霸赛'
    }
  },
  {
    name: 'play',
    path: '/reality/play/:cupId(\\d+)/:gameId(\\d+)/:kid(\\d+)',
    component: RealityPlay,
    props: true,
    meta: {
      title: '做题-斗K“股神”训练争霸赛',
      tabIndex: -1
    }
  },
  {
    name: 'finish',
    path: '/reality/finish/:cupId(\\d+)/',
    component: RealityFinish,
    props: true,
    meta: {
      title: '结果-斗K“股神”训练争霸赛',
      tabIndex: -1
    }
  },
  
  {
    name: 'awards',
    path: '/match/awards',
    component: Awards,
    meta: {
      title: '奖项设置-斗K“股神”训练争霸赛',
      tabIndex: 1
    }
  },
  {
    name: 'rules',
    path: '/match/rules',
    component: MatchRules,
    meta: {
      title: '活动规则-斗K“股神”训练争霸赛',
      tabIndex: 999
    }
  },
  {
    name: 'pre',
    path: '/match/pre',
    component: MatchPre,
    meta: {
      title: '初赛-斗K“股神”训练争霸赛',
      tabIndex: 2
    }
  },
  {
    name: 'final',
    path: '/match/final',
    component: MatchFinal,
    meta: {
      title: '决赛-斗K“股神”训练争霸赛',
      tabIndex: 3
    }
  },
  {
    name: 'winners',
    path: '/match/winners',
    component: Winners,
    meta: {
      title: '颁奖名单-斗K“股神”训练争霸赛',
      tabIndex: 4
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

function scrollBehavior () {
  return { x: 0, y: 0 }
}

const router = new Router({ routes, scrollBehavior });
// const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});
// router.afterEach((to) => {
//   const appName = /\/(reality|match)\/?/.test(to.path) ? RegExp.$1 : 'match'
//   let className = document.body.className || ''
//   className = className.replace(/\b(?:reality|match)\b/g, appName)
//   document.body.className = className
//   console.log(className);
// });
// router.onReady(function (params) {
//   console.log(JSON.stringify(params, null, 2))
// })

export {
  router
};
